import { picturePLaceholder } from "assets/icons";
import { Button, Input, LoadingButton, Select } from "components/form";
import React, { useEffect, useState } from "react";
import { uploadFileApi } from "services/media";
import { toast } from "sonner";
import { capitalizeFirstLetter } from "utils/commonHelper";
import { imageFileHandler, showImageHolder } from "utils/mediaHelper";
import OptionRowSkipSurvey from "./OptionRowSkipSurvey";
import { useTranslation } from "react-i18next";

const SliderRatingSkipSurvey = ({
  indexValue,
  handleClose,
  selectedQues,
  selectedBlock,
  skipDropdownList,
  surveyQuestionArray,
  setSurveyQuestionArray,
}) => {
  //********************************** Handle All State *********************************//

  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
  const { t } = useTranslation();

  const [selectedValues, setSelectedValues] = useState({
    goTo: "",
    value: "",
    option: null,
    condition: "",
  });

  const [skipQuestionSelected, setSkipQuestionSelected] = useState({
    ...selectedQues,
  });

  const [
    surveyQuestionArrCloneWithSkipQues,
    setSurveyQuestionArrCloneWithSkipQues,
  ] = useState();

  const END_OPTION = [
    { id: 1, value: "isSurveyEnd", label: "End the Survey" },
    { id: 2, value: "isBlockEnd", label: "End the Section" },
  ];

  const SKIP_OPTION = [
    { id: 1, value: "greater_than", label: "Greater Than" },
    { id: 2, value: "greater_than_or_equal", label: "Greater Than or Equal" },
    { id: 3, value: "less_than", label: "Less Than" },
    { id: 4, value: "less_than_or_equal", label: "Less Than or Equal" },
    { id: 5, value: "equal", label: "Equal" },
    { id: 6, value: "not_equal", label: "Not Equal" },
    { id: 7, value: "empty", label: "Empty" },
    { id: 8, value: "not_empty", label: "Not Empty" },
  ];

  //*********************************** Handle All Function *********************************//

  // skipLogic onChangeHandler
  const skipQuestionOnChangeHandler = (e) => {
    const { name, value } = e.target;
    setSelectedValues({ ...selectedValues, [name]: value });
  };

  const disableHandler = () => {
    let isDisabled = false;

    if (
      !selectedValues?.goTo ||
      !selectedValues?.option ||
      !selectedValues?.condition ||
      !selectedValues?.value
    ) {
      isDisabled = true;
    }

    return isDisabled;
  };

  const setSkipQuestionConfirmHandler = () => {
    let surveyQuesArrClone = { ...surveyQuestionArray };
    let blockQuesArrClone = surveyQuesArrClone[selectedBlock];
    let selectedQuestionForSkip = { ...selectedQues };

    let optionArrayClone = selectedQuestionForSkip?.option?.map((el) => el);

    let findOptIndex = optionArrayClone.findIndex(
      (el) => el?.optionValue === selectedValues?.option
    );

    let findOptObj = optionArrayClone.find(
      (el) => el?.optionValue === selectedValues?.option
    );

    findOptObj = {
      ...findOptObj,
      cond: selectedValues?.condition,
      condValue: selectedValues?.value,
      isBlockEnd: selectedValues?.goTo === "isBlockEnd" ? true : false,
      isSurveyEnd: selectedValues?.goTo === "isSurveyEnd" ? true : false,
    };

    optionArrayClone[findOptIndex] = { ...findOptObj };

    selectedQuestionForSkip = {
      ...selectedQuestionForSkip,
      option: optionArrayClone?.map((el) => el),
    };

    blockQuesArrClone[indexValue] = {
      ...selectedQuestionForSkip,
    };

    // setSkipQuestionSelected(blockQuesArrClone[indexValue]);

    surveyQuesArrClone = {
      ...surveyQuesArrClone,
      [selectedBlock]: blockQuesArrClone?.map((el) => el),
    };

    setSurveyQuestionArray(surveyQuesArrClone);
    toast.success(t(`CUSTOMIZATION_QUESTION.skipLogicAddSuccessfully`));
    handleClose();
  };

  //   skip survey confirm handler
  const skipSurveyOnConfirmHandler = () => {
    setSurveyQuestionArray(surveyQuestionArrCloneWithSkipQues);
    toast.success(t(`CUSTOMIZATION_QUESTION.skipLogicAddSuccessfully`));
    handleClose();
  };

  useEffect(() => {
    const getSelectedValuesForSkip = () => {
      let selectedValueClone =
        selectedQues?.option?.find(
          (el) => el?.cond?.length > 0 && el?.condValue?.length > 0
        ) || null;

      if (selectedValueClone) {
        setSelectedValues({
          condition: selectedValueClone?.cond,
          value: selectedValueClone?.condValue,
          option: selectedValueClone?.optionValue,
          goTo: selectedValueClone?.isSurveyEnd
            ? t(`CUSTOMIZATION_QUESTION.isSurveyEnd`)
            : t(`CUSTOMIZATION_QUESTION.isBlockEnd`),
        });
      }
    };

    getSelectedValuesForSkip();
  }, []);

  //************************************** Handle HTML CODE *********************************//
  return (
    <>
      {/* prev code */}
      <div className="">
        <h3>{t(`CUSTOMIZATION_QUESTION.skipLogic`)}</h3>
        <p>{selectedQues?.question || "----"}</p>

        <div className="form_field_wrap">
          <div className="form_field mx-2">
            <Select
              label={t(`CUSTOMIZATION_QUESTION.goto`)}
              name="goTo"
              value={selectedValues?.goTo}
              onChange={skipQuestionOnChangeHandler}
            >
              <option value="">{t(`CUSTOMIZATION_QUESTION.selectGoto`)}</option>
              {END_OPTION?.map((el) => (
                <option key={el?.id} value={el?.value}>
                  {t(`CUSTOMIZATION_QUESTION.${el?.label}`)}
                </option>
              ))}
            </Select>
          </div>
          <div className="form_field">
            <Select
              name="option"
              label={t(`CUSTOMIZATION_QUESTION.selectOption`)}
              value={selectedValues?.option}
              onChange={skipQuestionOnChangeHandler}
            >
              <option value="">
                {t(`CUSTOMIZATION_QUESTION.selectOption`)}
              </option>
              {selectedQues?.option?.length > 0 &&
                selectedQues?.option?.map((el, ind) => (
                  <option
                    value={el?.optionValue}
                    key={`dropDownQues${ind + 2}`}
                  >
                    {`${el?.optionValue}`}
                  </option>
                ))}
            </Select>
          </div>
          <div className="form_field mx-2">
            <Select
              name="condition"
              label={t(`CUSTOMIZATION_QUESTION.condition`)}
              value={selectedValues?.condition}
              onChange={skipQuestionOnChangeHandler}
            >
              <option value="">
                {" "}
                {t(`CUSTOMIZATION_QUESTION.selectCondition`)}
              </option>
              {SKIP_OPTION?.map((el) => (
                <option key={el?.id} value={el?.value}>
                  {t(`CUSTOMIZATION_QUESTION.${el?.label}`)}
                </option>
              ))}
            </Select>
          </div>

          <div className="form_field">
            <Input
              type="text"
              name="value"
              label={t(`CUSTOMIZATION_QUESTION.value`)}
              placeholder={t(`CUSTOMIZATION_QUESTION.enterValue`)}
              value={selectedValues?.value}
              onChange={skipQuestionOnChangeHandler}
            />
          </div>
        </div>

        {/* {selectedQues?.option?.length > 0 &&
          selectedQues?.option?.map((option, index) => {
            return (
              <div key={`skipQuesOpt${index}`}>
                <OptionRowSkipSurvey
                  ind={index}
                  optionData={option}
                  skipDropdownList={skipDropdownList}
                  questionDropdownOnChangeHandler={
                    questionDropdownOnChangeHandler
                  }
                />
              </div>
            );
          })} */}

        <div className="button_wrap button_center">
          <Button className={"light"} onClick={handleClose}>
            {t(`CUSTOMIZATION_QUESTION.enterValue`)}
          </Button>

          <Button
            isDisabled={disableHandler()}
            onClick={setSkipQuestionConfirmHandler}
          >
            {t(`CUSTOMIZATION_QUESTION.confirm`)}
          </Button>

          {/* <LoadingButton
            loading={submitButtonLoading}
            onClick={skipSurveyOnConfirmHandler}
          >
            Confirm
          </LoadingButton> */}
        </div>
      </div>
    </>
  );
};

export default SliderRatingSkipSurvey;
